<pos-list
  [data]="products"
  [filters]="filters"
  [config]="{ title: 'code', description: 'description', showActiveRow: true, badge:'stock' }"
  [itemsPerPage]="5"
  (dataChange)="getProductData($event)"
  (rowClick)="productRowClick($event)"
></pos-list>
